/**
 * Loads the application afresh at path. Used on sign-out: a full load leaves
 * nothing of the previous user in memory and lands on the same page whichever
 * screen the user signed out from.
 */
export function reloadAt(path: string): void {
  window.location.assign(path);
}
